// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Utils_Image$LiveRoom from "../Utils/Utils_Image.bs.js";
import * as CommonStyles$LiveRoom from "../styles/CommonStyles.bs.js";
import * as ResponsiveImage$LiveRoom from "../ResponsiveImage.bs.js";

function imageStyle(faded) {
  return Curry._1(Css.style, {
              hd: Css.margin(Css.auto),
              tl: {
                hd: Css.objectFit("contain"),
                tl: {
                  hd: faded ? Css.opacity(0.6) : Css.opacity(1),
                  tl: {
                    hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                          hd: Css.maxHeight(Css.px(84)),
                          tl: {
                            hd: Css.maxWidth(Css.px(84)),
                            tl: /* [] */0
                          }
                        }),
                    tl: {
                      hd: CommonStyles$LiveRoom.mediaV2(/* DesktopAndTabletLandscape */4, {
                            hd: Css.maxHeight(Css.px(64)),
                            tl: {
                              hd: Css.maxWidth(Css.px(64)),
                              tl: /* [] */0
                            }
                          }),
                      tl: {
                        hd: CommonStyles$LiveRoom.mediaV2(/* Desktop */0, {
                              hd: Css.maxHeight(Css.px(84)),
                              tl: {
                                hd: Css.maxWidth(Css.px(84)),
                                tl: /* [] */0
                              }
                            }),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            });
}

function LotCardImage(props) {
  var faded = props.faded;
  var faded$1 = faded !== undefined ? faded : false;
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.display("flex"),
                    tl: {
                      hd: Css.alignItems(Css.center),
                      tl: {
                        hd: Css.height(Css.px(64)),
                        tl: {
                          hd: Css.width(Css.px(64)),
                          tl: {
                            hd: CommonStyles$LiveRoom.mediaV2(/* Desktop */0, {
                                  hd: Css.height(Css.px(84)),
                                  tl: {
                                    hd: Css.width(Css.px(84)),
                                    tl: /* [] */0
                                  }
                                }),
                            tl: {
                              hd: Css.overflow(Css.hidden),
                              tl: {
                                hd: Css.unsafe("float", "left"),
                                tl: {
                                  hd: Css.fontSize(Css.px(8)),
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  })
            }, React.createElement(ResponsiveImage$LiveRoom.make, {
                  imageRenditions: Utils_Image$LiveRoom.getBrightspotPrimaryRenditions(undefined, "lot", props.lotId),
                  alt: "",
                  sizes: {
                    responsiveWidths: undefined,
                    default: {
                      NAME: "px",
                      VAL: 84
                    }
                  },
                  className: imageStyle(faded$1),
                  lazyLoading: true
                }));
}

var imageLarge = 84;

var imageSmall = 64;

var make = LotCardImage;

export {
  imageLarge ,
  imageSmall ,
  imageStyle ,
  make ,
}
/* Css Not a pure module */
